module.exports = __webpack_public_path__ + "f5324dd2552a39a326c3efdecac67a87.png";